'use client';
import React from 'react';
import { MlCardBase } from './ml-card-base';
import { IMlCardProps, EMlCardsTypes } from './ml-card.types';
import { AtClickable, AtIcon } from '@/components/atoms';
import { EIcons } from '@/components/atoms/at-icon/icons';

export const MlCardClient = (props: IMlCardProps) => {
  const handleClick = () => {
    if (typeof props.onClick === 'function') {
      props.onClick();
    }
  };

  const patchedProps = {
    ...props,
    onFocus: props.onFocus,
    ariaLabel: props.ariaLabel,
  };

  return (
    <div onClick={handleClick}>
      <MlCardBase {...patchedProps} />
      {props.variant === EMlCardsTypes.HOME_PLAN &&
        props.showFavouriteButton &&
        props.homePlanProps?.onSaveHomePlanClick && (
          <AtClickable
            onClick={(e) => {
              e.stopPropagation();
              props.homePlanProps?.onSaveHomePlanClick?.();
            }}
            className="absolute right-0 top-0 h-fit !p-0"
            ariaLabel={
              props.homePlanProps.likePlanAriaLabel || 'Favorite this Plan'
            }
            interactLocation="ml-card"
          >
            <AtIcon icon={EIcons.HEART} className="h-6 w-6" />
          </AtClickable>
        )}
    </div>
  );
};
